export const seoConfig = {
  default: {
    title: 'Blue Panda Digital Marketing',
    description: 'Professional digital marketing services for businesses. Web development, graphic design & SEO solutions.',
    keywords: 'digital marketing, SEO, web development, graphic design, social media marketing',
    url: 'https://bluepandadigitalmarketing.com',
    image: 'https://bluepandadigitalmarketing.com/og-image.jpg',
  },
  home: {
    title: 'Blue Panda Digital Marketing - Digital Marketing Services',
    description: 'Professional digital marketing services for businesses. Web development, graphic design & SEO solutions in Vadodara.',
    keywords: 'digital marketing services, web development, graphic design',
  },
  digitalMarketing: {
    title: 'Digital Marketing Services - Blue Panda',
    description: 'Expert digital marketing services including SEO, social media, PPC & content marketing.',
    keywords: 'Digital Marketing Services, SEO, PPC, Social Media',
  },
  webDevelopment: {
    title: 'Web Development Services - Blue Panda',
    description: 'Custom web development solutions for businesses. Responsive, fast & SEO-friendly websites.',
    keywords: 'Web Development Services, custom website, responsive web design',
  },
  graphicDesign: {
    title: 'Graphic Design Services - Blue Panda',
    description: 'Professional graphic design services for branding, logos, and visual identity.',
    keywords: 'Graphic Design Services, branding, logo design',
  },
  digitalMarketingVadodara: {
    title: 'Digital Marketing Services in Vadodara - Blue Panda',
    description: 'Best digital marketing agency in Vadodara offering SEO, social media & paid advertising.',
    keywords: 'Digital Marketing Services Vadodara, best agency in Vadodara',
  },
  blog: {
    title: 'Blog - Blue Panda Digital Marketing',
    description: 'Read the latest insights, tips, and news on digital marketing, web development, and design.',
    keywords: 'digital marketing blog, marketing tips, SEO news',
  },
  about: {
    title: 'About Blue Panda Digital Marketing',
    description: 'Learn about our team, mission, and expertise in digital marketing.',
    keywords: 'about blue panda, digital marketing team, our mission',
  },
  contact: {
    title: 'Contact Us - Blue Panda Digital Marketing',
    description: 'Get in touch with our digital marketing experts. Quick response guaranteed.',
    keywords: 'contact blue panda, digital marketing consultation',
  },
  portfolio: {
    title: 'Portfolio - Blue Panda Digital Marketing',
    description: 'Check out our successful digital marketing campaigns and client case studies.',
    keywords: 'digital marketing portfolio, case studies, success stories',
  },
};
